import { FormControl, FormGroup } from '@angular/forms';

import { FileForm } from './file-form';

export class ProposalFileForm extends FormGroup<{
  id: FormControl<undefined | number>;
  ProposalId: FormControl<undefined | number>;
  FileId: FormControl<undefined | number>;
  isArchived: FormControl<undefined | boolean>;

  File: FileForm;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      ProposalId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      FileId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      isArchived: new FormControl<undefined | boolean>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),

      File: new FileForm()
    });
  }
}
